export default "__VITE_ASSET__33i0$Xwy__"